import { ToastType } from './toast-type';

export class ToastData {
  type: ToastType;
  title?: string;
  text?: string;
  secondsDurantion?: number;
  delayTime?: boolean;
}
